/**
 * KOMBAT ZONE — Product Quick-Buy Modal
 * File: assets/kz-product-modal.js
 */

(function () {
  'use strict';

  if (window._kzModalLoaded) return;
  window._kzModalLoaded = true;

  let currentProduct = null;
  let selectedVariantId = null;
  let modalSelectedOptions = [];
  let randomViewers = 12;
  let viewersTimer = null;

  const isEnglishStore = location.hostname === 'kombatzone.shop';
  const overlay = document.getElementById('kz-modal-overlay');
  const closeBtn = document.getElementById('kz-modal-close');
  const addBtn = document.getElementById('kz-modal-add-btn');
  const productLink = document.getElementById('kz-modal-product-link');
  const toast = document.getElementById('kz-modal-toast');

  if (!overlay) return;

  const SLIDE_INTERVAL_MS = 4000;
  let slideImages = [];
  let slideIndex = 0;
  let slideTimer = null;
  let slidePaused = false;
  let progressFills = [];
  let pausedAt = 0;

  function injectModalEnhancementStyles() {
    if (document.getElementById('kz-modal-enhancement-styles')) return;
    const style = document.createElement('style');
    style.id = 'kz-modal-enhancement-styles';
    style.textContent = `
      .kz-modal-thumbs-shell {
        display: grid;
        grid-template-columns: 34px minmax(0,1fr) 34px;
        align-items: center;
        gap: 4px;
        padding: 0 8px;
        border-top: 1px solid rgba(255,255,255,.06);
        background: #0d0d0d;
      }
      .kz-modal-thumbs-shell .kz-modal-thumbs {
        display: flex !important;
        flex-wrap: nowrap !important;
        gap: 6px !important;
        overflow-x: auto !important;
        overflow-y: hidden !important;
        scroll-behavior: smooth;
        scrollbar-width: none;
        -ms-overflow-style: none;
        padding: 10px 2px !important;
        border-top: 0 !important;
        min-width: 0;
      }
      .kz-modal-thumbs-shell .kz-modal-thumbs::-webkit-scrollbar { display: none; }
      .kz-modal-thumbs-shell .kz-modal-thumb { flex: 0 0 44px !important; }
      .kz-modal-thumb-nav {
        width: 30px;
        height: 30px;
        border: 1px solid rgba(255,255,255,.16);
        border-radius: 50%;
        background: #171717;
        color: #f2f0eb;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        font-size: 20px;
        line-height: 1;
        transition: border-color .15s ease, background .15s ease, transform .15s ease;
      }
      .kz-modal-thumb-nav:hover { border-color: #E8272A; background: #202020; transform: scale(1.05); }
      .kz-modal-thumb-nav:disabled { opacity: .25; cursor: default; transform: none; }
      .kz-modal-swatch {
        background-clip: padding-box !important;
        box-shadow: none !important;
        outline: none !important;
        overflow: hidden !important;
      }
      .kz-modal-swatch.active,
      .kz-modal-swatch:focus,
      .kz-modal-swatch:focus-visible { box-shadow: none !important; outline: none !important; }
      @media (max-width: 640px) {
        .kz-modal-thumbs-shell { grid-template-columns: 30px minmax(0,1fr) 30px; padding: 0 5px; }
        .kz-modal-thumb-nav { width: 27px; height: 27px; font-size: 18px; }
      }
    `;
    document.head.appendChild(style);
  }

  function ensureThumbScroller() {
    const thumbsWrap = document.getElementById('kz-modal-thumbs');
    if (!thumbsWrap) return null;
    if (thumbsWrap.parentElement && thumbsWrap.parentElement.classList.contains('kz-modal-thumbs-shell')) {
      return thumbsWrap.parentElement;
    }

    const shell = document.createElement('div');
    shell.className = 'kz-modal-thumbs-shell';

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'kz-modal-thumb-nav kz-modal-thumb-nav--prev';
    prev.setAttribute('aria-label', isEnglishStore ? 'Previous images' : 'Immagini precedenti');
    prev.innerHTML = '&#8249;';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'kz-modal-thumb-nav kz-modal-thumb-nav--next';
    next.setAttribute('aria-label', isEnglishStore ? 'Next images' : 'Immagini successive');
    next.innerHTML = '&#8250;';

    thumbsWrap.parentNode.insertBefore(shell, thumbsWrap);
    shell.appendChild(prev);
    shell.appendChild(thumbsWrap);
    shell.appendChild(next);

    const scrollAmount = () => Math.max(180, Math.round(thumbsWrap.clientWidth * 0.75));
    prev.addEventListener('click', () => thumbsWrap.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next.addEventListener('click', () => thumbsWrap.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    thumbsWrap.addEventListener('scroll', updateThumbNavState, { passive: true });
    window.addEventListener('resize', updateThumbNavState);

    return shell;
  }

  function updateThumbNavState() {
    const thumbsWrap = document.getElementById('kz-modal-thumbs');
    const shell = thumbsWrap && thumbsWrap.parentElement;
    if (!thumbsWrap || !shell || !shell.classList.contains('kz-modal-thumbs-shell')) return;
    const prev = shell.querySelector('.kz-modal-thumb-nav--prev');
    const next = shell.querySelector('.kz-modal-thumb-nav--next');
    const maxScroll = Math.max(0, thumbsWrap.scrollWidth - thumbsWrap.clientWidth);
    if (prev) prev.disabled = thumbsWrap.scrollLeft <= 2;
    if (next) next.disabled = thumbsWrap.scrollLeft >= maxScroll - 2;
    shell.style.display = slideImages.length > 0 ? 'grid' : 'none';
  }

  function scheduleNextSlide(delay) {
    clearTimeout(slideTimer);
    slideTimer = null;
    if (slideImages.length <= 1) return;
    slideTimer = setTimeout(() => {
      if (!slidePaused) {
        slideTo(slideIndex + 1);
        scheduleNextSlide(SLIDE_INTERVAL_MS);
      }
    }, delay);
  }

  function startSlideTimer() {
    scheduleNextSlide(SLIDE_INTERVAL_MS);
  }

  function pauseSlideshow() {
    slidePaused = true;
    clearTimeout(slideTimer);
    slideTimer = null;
    const fill = progressFills[slideIndex];
    if (fill) {
      const fillW = parseFloat(getComputedStyle(fill).width) || 0;
      const segW = fill.parentElement ? fill.parentElement.getBoundingClientRect().width : 0;
      pausedAt = segW > 0 ? fillW / segW : 0;
      fill.style.animation = 'none';
      fill.style.width = (pausedAt * 100) + '%';
    }
  }

  function resumeSlideshow() {
    slidePaused = false;
    const fill = progressFills[slideIndex];
    const remaining = Math.max(200, Math.round((1 - pausedAt) * SLIDE_INTERVAL_MS));
    if (fill) {
      const elapsed = Math.round(pausedAt * SLIDE_INTERVAL_MS);
      fill.style.animation = 'none';
      fill.style.width = '';
      void fill.offsetWidth;
      fill.style.animation = `kz-progress-grow ${SLIDE_INTERVAL_MS}ms linear -${elapsed}ms forwards`;
    }
    scheduleNextSlide(remaining);
  }

  function normalizedImageKey(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url, location.origin);
      return parsed.pathname.replace(/_[0-9]+x(?=\.)/i, '').toLowerCase();
    } catch (_) {
      return String(url).split('?')[0].toLowerCase();
    }
  }

  function scrollActiveThumbIntoView() {
    const thumbsWrap = document.getElementById('kz-modal-thumbs');
    if (!thumbsWrap) return;
    const active = thumbsWrap.querySelector('.kz-modal-thumb.active');
    if (!active) return;
    const target = active.offsetLeft - Math.max(0, (thumbsWrap.clientWidth - active.offsetWidth) / 2);
    thumbsWrap.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    setTimeout(updateThumbNavState, 180);
  }

  function slideTo(index) {
    if (slideImages.length === 0) return;
    slideIndex = ((index % slideImages.length) + slideImages.length) % slideImages.length;

    const mainImg = document.getElementById('kz-modal-main-img');
    const thumbsWrap = document.getElementById('kz-modal-thumbs');

    if (mainImg) {
      mainImg.classList.add('kz-fade');
      setTimeout(() => {
        mainImg.src = slideImages[slideIndex];
        mainImg.classList.remove('kz-fade');
      }, 160);
    }

    if (thumbsWrap) {
      thumbsWrap.querySelectorAll('.kz-modal-thumb').forEach((t, i) => t.classList.toggle('active', i === slideIndex));
      scrollActiveThumbIntoView();
    }

    progressFills.forEach((fill, i) => {
      fill.style.animation = 'none';
      void fill.offsetWidth;
      if (i < slideIndex) {
        fill.style.width = '100%';
      } else if (i === slideIndex && !slidePaused && slideImages.length > 1) {
        fill.style.width = '0%';
        fill.style.animation = `kz-progress-grow ${SLIDE_INTERVAL_MS}ms linear forwards`;
      } else {
        fill.style.width = '0%';
      }
    });
  }

  function buildProgressBar() {
    const wrap = document.getElementById('kz-modal-progress');
    if (!wrap) return;
    wrap.innerHTML = '';
    progressFills = [];
    slideImages.forEach(() => {
      const seg = document.createElement('div');
      seg.className = 'kz-modal-progress-seg';
      const fill = document.createElement('div');
      fill.className = 'kz-modal-progress-fill';
      seg.appendChild(fill);
      wrap.appendChild(seg);
      progressFills.push(fill);
    });
    wrap.style.display = slideImages.length > 1 ? 'flex' : 'none';
  }

  function renderThumbnails() {
    const thumbsWrap = document.getElementById('kz-modal-thumbs');
    if (!thumbsWrap) return;
    thumbsWrap.innerHTML = '';
    slideImages.forEach((imgUrl, i) => {
      const div = document.createElement('div');
      div.className = 'kz-modal-thumb' + (i === slideIndex ? ' active' : '');
      const img = document.createElement('img');
      img.src = imgUrl;
      img.alt = '';
      img.loading = 'lazy';
      div.appendChild(img);
      div.addEventListener('click', () => {
        slideTo(i);
        if (!slidePaused) startSlideTimer();
      });
      thumbsWrap.appendChild(div);
    });
    thumbsWrap.scrollLeft = 0;
    requestAnimationFrame(updateThumbNavState);
  }

  function variantImageUrl(variant) {
    if (!variant) return '';
    return variant.featured_image?.src
      || variant.featured_media?.preview_image?.src
      || variant.featured_media?.preview_image?.url
      || '';
  }

  function showVariantImage(variant) {
    const url = variantImageUrl(variant);
    if (!url) return;
    const key = normalizedImageKey(url);
    let idx = slideImages.findIndex(img => normalizedImageKey(img) === key);

    if (idx === -1) {
      slideImages.push(url);
      idx = slideImages.length - 1;
      buildProgressBar();
      renderThumbnails();
    }

    slideTo(idx);
    if (!slidePaused) startSlideTimer();
  }

  const VIEWERS_UPDATE_MS = 60000;

  function hashStringToInt(str) {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) - hash + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash);
  }

  function getBaseViewers(handle) {
    const seed = hashStringToInt(handle || 'kz-default');
    return 6 + (seed % 23);
  }

  function renderViewers() {
    const el = document.getElementById('kz-modal-viewers');
    if (el) el.textContent = `${randomViewers} ${isEnglishStore ? 'people' : 'persone'}`;
  }

  function startViewersTimer(handle) {
    stopViewersTimer();
    randomViewers = Math.max(3, getBaseViewers(handle) + Math.floor(Math.random() * 13) - 4);
    renderViewers();
    viewersTimer = setInterval(() => {
      const base = getBaseViewers(handle);
      const delta = Math.floor(Math.random() * 9) - 4;
      randomViewers = Math.max(3, base + delta);
      renderViewers();
    }, VIEWERS_UPDATE_MS);
  }

  function stopViewersTimer() {
    clearInterval(viewersTimer);
    viewersTimer = null;
  }

  function populateModal(product) {
    document.getElementById('kz-modal-title').textContent = product.title;
    document.getElementById('kz-modal-category').textContent = product.type ? `${product.type} · ${product.vendor}` : product.vendor;
    productLink.href = `/products/${product.handle}`;

    const qtyEl = document.getElementById('kz-modal-qty-input');
    if (qtyEl) qtyEl.value = 1;
    const addedEl = document.getElementById('kz-modal-added');
    if (addedEl) addedEl.classList.remove('show');

    slideImages = Array.from(new Set((product.images || []).filter(Boolean)));
    slideIndex = 0;
    slidePaused = false;
    clearTimeout(slideTimer);
    slideTimer = null;

    buildProgressBar();
    renderThumbnails();

    const mainImg = document.getElementById('kz-modal-main-img');
    if (mainImg && slideImages.length > 0) {
      mainImg.src = slideImages[0];
      mainImg.alt = product.title;
    }

    const imgWrap = document.getElementById('kz-modal-img-wrap');
    if (imgWrap) {
      imgWrap.onclick = e => {
        const zone = e.target && e.target.getAttribute ? e.target.getAttribute('data-kz-tap') : null;
        if (zone === 'prev') {
          slideTo(slideIndex - 1);
          if (!slidePaused) startSlideTimer();
        } else if (zone === 'next') {
          slideTo(slideIndex + 1);
          if (!slidePaused) startSlideTimer();
        } else {
          if (slidePaused) resumeSlideshow();
          else pauseSlideshow();
        }
      };
    }

    const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
    selectedVariantId = firstAvailable?.id || null;
    modalSelectedOptions = firstAvailable?.options ? firstAvailable.options.slice() : [];
    renderVariants(product);
    if (firstAvailable) {
      updatePrice(firstAvailable);
      updateStock(firstAvailable);
      showVariantImage(firstAvailable);
    }

    if (slideImages.length > 0) slideTo(slideIndex);
    startSlideTimer();
    startViewersTimer(product.handle);
    requestAnimationFrame(updateThumbNavState);
  }

  function translateOptionName(name) {
    const t = isEnglishStore
      ? { size:'Size', taglia:'Size', color:'Color', colour:'Color', colore:'Color', title:'Variant', 'pantaloncini e protezioni':'Shorts & Protection', pantaloncini:'Shorts', 'casco e parastinchi':'Headgear & Shin Guards', 'scarpe da boxe':'Boxing Shoes', oz:'Oz' }
      : { size:'Taglia', taglia:'Taglia', color:'Colore', colour:'Colore', colore:'Colore', title:'Variante' };
    return t[(name || '').trim().toLowerCase()] || name;
  }

  function isColorOption(name) {
    const n = (name || '').trim().toLowerCase();
    return n === 'color' || n === 'colour' || n === 'colore';
  }

  function modalColorPaint(value) {
    const palette = {
      black:'#111111', white:'#f4f4f2', grey:'#85888a', gray:'#85888a',
      red:'#d9272e', blue:'#246fc4', navy:'#14284b', green:'#3b9b61',
      yellow:'#f0c431', orange:'#e56d24', purple:'#7854a9',
      plum:'#713957', pink:'#db82a6', fuchsia:'#e6007e', burgundy:'#800020', bordeaux:'#7f1734',
      brown:'#6f472e', beige:'#d5c4a0', gold:'#c7a24b', silver:'#b8bcc2',
      cyan:'#3ca6d8', turquoise:'#25a7a4', teal:'#277b7c', clear:'#f4f4f2'
    };
    const names = String(value || '').split(/\s*(?:\/|&|\+)\s*/).map(name => name.trim().toLowerCase()).filter(Boolean);
    const colors = names.map(name => {
      if (palette[name]) return palette[name];
      const key = Object.keys(palette).find(candidate => name.includes(candidate));
      if (key) return palette[key];
      return window.CSS && CSS.supports && CSS.supports('color', name) ? name : '#8a8d91';
    });
    if (colors.length <= 1) return colors[0] || '#8a8d91';
    const step = 100 / colors.length;
    return 'linear-gradient(90deg,' + colors.map((color, index) =>
      color + ' ' + Math.round(index * step) + '%,' + color + ' ' + Math.round((index + 1) * step) + '%'
    ).join(',') + ')';
  }

  function findMatchingVariant(product) {
    return product.variants.find(v => v.options.every((o, i) => o === modalSelectedOptions[i]));
  }

  function valueAvailable(product, optIndex, value, optName) {
    if (isColorOption(optName)) {
      return product.variants.some(v => v.available && v.options[optIndex] === value);
    }
    return product.variants.some(v =>
      v.available &&
      v.options[optIndex] === value &&
      v.options.every((o, i) => i === optIndex || o === modalSelectedOptions[i])
    );
  }

  function resolveVariantAfterOptionClick(product, optIndex, value) {
    const desired = modalSelectedOptions.slice();
    desired[optIndex] = value;

    let match = product.variants.find(v => v.options.every((o, i) => o === desired[i]) && v.available);
    if (!match) match = product.variants.find(v => v.options[optIndex] === value && v.available);
    if (!match) match = product.variants.find(v => v.options.every((o, i) => o === desired[i]));
    if (!match) match = product.variants.find(v => v.options[optIndex] === value);
    return match || null;
  }

  function renderVariants(product) {
    const wrap = document.getElementById('kz-modal-variants-wrap');
    if (!wrap) return;
    wrap.innerHTML = '';

    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      wrap.style.display = 'none';
      return;
    }
    wrap.style.display = 'block';

    const current = product.variants.find(v => v.id === selectedVariantId) || product.variants[0];
    if (current?.options) modalSelectedOptions = current.options.slice();

    (product.options || []).forEach((opt, optIndex) => {
      const optName = typeof opt === 'string' ? opt : (opt.name || '');
      const optValues = [...new Set(product.variants.map(v => v.options[optIndex]))];

      const label = document.createElement('div');
      label.className = 'kz-modal-label';
      label.textContent = translateOptionName(optName);
      wrap.appendChild(label);

      const group = document.createElement('div');
      group.className = 'kz-modal-variants' + (isColorOption(optName) ? ' kz-modal-swatches' : '');

      optValues.forEach(value => {
        const btn = document.createElement('button');
        btn.type = 'button';
        if (isColorOption(optName)) {
          btn.className = 'kz-modal-swatch';
          btn.style.background = modalColorPaint(value);
          btn.setAttribute('aria-label', value);
          btn.setAttribute('title', value);
        } else {
          btn.className = 'kz-modal-var-btn';
          btn.textContent = value;
        }

        if (modalSelectedOptions[optIndex] === value) btn.classList.add('active');
        if (!valueAvailable(product, optIndex, value, optName)) btn.classList.add('unavailable');

        btn.addEventListener('click', () => {
          if (btn.classList.contains('unavailable')) return;
          const match = resolveVariantAfterOptionClick(product, optIndex, value);
          if (!match) return;

          selectedVariantId = match.id;
          modalSelectedOptions = match.options.slice();
          updatePrice(match);
          updateStock(match);
          if (isColorOption(optName)) showVariantImage(match);
          renderVariants(product);
        });

        group.appendChild(btn);
      });
      wrap.appendChild(group);
    });

    const divider = document.createElement('div');
    divider.className = 'kz-modal-divider';
    wrap.appendChild(divider);
  }

  function updatePrice(variant) {
    const priceEl = document.getElementById('kz-modal-price');
    const oldEl = document.getElementById('kz-modal-price-old');
    const saveEl = document.getElementById('kz-modal-price-save');
    if (!priceEl) return;

    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      if (oldEl) {
        oldEl.textContent = formatMoney(variant.compare_at_price);
        oldEl.style.display = '';
      }
      if (saveEl) {
        const pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        saveEl.textContent = `−${pct}%`;
        saveEl.style.display = '';
      }
    } else {
      if (oldEl) oldEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
    }
  }

  function updateStock(variant) {
    const stockWrap = document.getElementById('kz-modal-stock-wrap');
    const stockNum = document.getElementById('kz-modal-stock-num');
    const stockFill = document.getElementById('kz-modal-stock-fill');

    if (!variant.available) {
      if (stockWrap) stockWrap.style.display = 'none';
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = isEnglishStore ? '✕ Sold out' : '✕ Esaurito';
      }
      return;
    }

    if (addBtn) {
      addBtn.disabled = false;
      addBtn.textContent = isEnglishStore ? 'Add to cart' : 'Aggiungi al carrello';
    }

    const qty = variant.inventory_quantity;
    if (stockWrap && qty !== undefined && qty !== null && qty <= 10 && qty > 0) {
      stockWrap.style.display = '';
      if (stockNum) stockNum.textContent = isEnglishStore ? `${qty} left` : `${qty} rimasti`;
      if (stockFill) stockFill.style.width = Math.min(100, Math.max(8, (qty / 18) * 100)) + '%';
    } else if (stockWrap) {
      stockWrap.style.display = 'none';
    }
  }

  const qtyInput = document.getElementById('kz-modal-qty-input');
  const qtyMinus = document.getElementById('kz-modal-qty-minus');
  const qtyPlus = document.getElementById('kz-modal-qty-plus');

  function getQty() {
    const v = parseInt(qtyInput && qtyInput.value, 10);
    return isNaN(v) || v < 1 ? 1 : v;
  }

  if (qtyMinus) qtyMinus.addEventListener('click', () => { if (qtyInput) qtyInput.value = Math.max(1, getQty() - 1); });
  if (qtyPlus) qtyPlus.addEventListener('click', () => { if (qtyInput) qtyInput.value = getQty() + 1; });

  const addedPop = document.getElementById('kz-modal-added');

  function showAddedPop() {
    if (!addedPop) { window.location.href = '/cart'; return; }
    addedPop.classList.add('show');
  }

  function hideAddedPop() {
    if (addedPop) addedPop.classList.remove('show');
  }

  const addedContinue = document.getElementById('kz-modal-added-continue');
  if (addedContinue) addedContinue.addEventListener('click', () => { hideAddedPop(); closeModal(); });
  if (addedPop) addedPop.addEventListener('click', e => { if (e.target === addedPop) hideAddedPop(); });

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      if (!selectedVariantId || addBtn.disabled) return;
      addBtn.disabled = true;
      addBtn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: getQty() })
      })
        .then(r => r.json())
        .then(() => {
          updateCartCount();
          addBtn.disabled = false;
          addBtn.textContent = isEnglishStore ? 'Add to cart' : 'Aggiungi al carrello';
          showAddedPop();
        })
        .catch(() => {
          addBtn.disabled = false;
          addBtn.textContent = isEnglishStore ? 'Add to cart' : 'Aggiungi al carrello';
          showToast(isEnglishStore ? 'Something went wrong — try again' : 'Errore — riprova');
        });
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const badge = document.querySelector('.kz-cart-count');
        if (!badge) return;
        badge.textContent = cart.item_count > 0 ? cart.item_count : '';
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
  }

  function closeModal() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    currentProduct = null;
    selectedVariantId = null;
    modalSelectedOptions = [];
    clearTimeout(slideTimer);
    slideTimer = null;
    slidePaused = false;
    stopViewersTimer();
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });

  const cursorX = document.getElementById('kz-modal-cursor-x');
  if (cursorX && window.matchMedia('(pointer: fine)').matches) {
    overlay.addEventListener('mousemove', e => {
      if (e.target === overlay) {
        cursorX.style.left = e.clientX + 'px';
        cursorX.style.top = e.clientY + 'px';
        cursorX.classList.add('show');
      } else {
        cursorX.classList.remove('show');
      }
    });
    overlay.addEventListener('mouseleave', () => cursorX.classList.remove('show'));
  }

  document.addEventListener('keydown', e => { if (e.key === 'Escape' && overlay.classList.contains('open')) closeModal(); });

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 3000);
  }

  function formatMoney(cents) {
    return '€' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
  }

  function openModal(handle) {
    fetch(`/products/${handle}.js`)
      .then(r => {
        if (!r.ok) throw new Error('Product load failed');
        return r.json();
      })
      .then(product => {
        currentProduct = product;
        populateModal(product);
        overlay.classList.add('open');
        document.body.style.overflow = 'hidden';
      })
      .catch(() => {
        showToast(isEnglishStore ? 'Unable to load product' : 'Impossibile caricare il prodotto');
      });
  }

  function initProductPageATC() {
    if (!document.body.classList.contains('template-product')) return;

    const productHandle = window.ShopifyAnalytics?.meta?.product?.handle
      || document.querySelector('[data-product-handle]')?.dataset?.productHandle
      || document.querySelector('meta[property="og:url"]')?.content?.match(/\/products\/([^/?#]+)/)?.[1];

    if (!productHandle) return;

    const atcSelectors = [
      '[data-type="add-to-cart-form"] button[type="submit"]',
      'product-form button[name="add"]',
      'form[action="/cart/add"] button[type="submit"]',
      '.product-form__submit',
      '#AddToCart'
    ].join(', ');

    function bindATC() {
      document.querySelectorAll(atcSelectors).forEach(btn => {
        if (btn.dataset.kzAtcBound) return;
        btn.dataset.kzAtcBound = 'true';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openModal(productHandle);
        }, true);
      });
    }

    bindATC();
    const observer = new MutationObserver(bindATC);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initCardLinks() {
    if (document.body.classList.contains('template-product')) return;

    function bindCards() {
      document.querySelectorAll('product-card a[href*="/products/"], li[data-product-id] a[href*="/products/"]').forEach(link => {
        if (link.dataset.kzBound) return;
        link.dataset.kzBound = 'true';
        link.addEventListener('click', function (e) {
          if (e.target.closest('add-to-cart-component')) return;
          if (e.target.closest('[data-quick-add-button]')) return;
          const match = link.href.match(/\/products\/([^?#/]+)/);
          if (!match) return;
          e.preventDefault();
          e.stopPropagation();
          openModal(match[1]);
        });
      });
    }

    bindCards();
    const observer = new MutationObserver(bindCards);
    const grid = document.querySelector('results-list, .product-grid-container, main');
    if (grid) observer.observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-kz-modal]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.kzModal;
    if (handle) openModal(handle);
  });

  injectModalEnhancementStyles();
  ensureThumbScroller();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      ensureThumbScroller();
      initProductPageATC();
      initCardLinks();
    });
  } else {
    initProductPageATC();
    initCardLinks();
  }
})();